<template>
  <div class="file-wrapper">
    <div class="md-layout align-center">
      <div class>
        <a :href="dataProps.link">{{ dataProps.link }}</a>
      </div>
      <div v-if="!noDelete" class>
        <md-button @click="$emit('delete')" class="md-icon-button">
          <md-icon>close</md-icon>
        </md-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "FbFileViewLink",
  props: ["dataProps", "no-delete"],
};
</script>

<style lang="scss">
.align-center {
  align-items: center;
}
.file-wrapper {
  padding: 0 0px;
}
</style>